import styled from "@emotion/styled";

import { SpacingToken } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withPx, withVar } from "themes/helpers";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${withVar(SpacingToken.Spacing1)};
  gap: ${withVar(SpacingToken.Spacing3)};
  @media screen and (max-width: ${withPx(ResponsiveBreakpoint.Mobile)}) {
    gap: ${withVar(SpacingToken.Spacing5)};
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${withVar(SpacingToken.Spacing4)};
`;

export const StyledRowName = styled.div`
  display: flex;
`;

export const StyledRowValue = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const StyledPriceRow = styled(StyledRow)`
  border-top: 1px solid ${(props): string => props.theme.borderColor};
  margin-bottom: 26px;
  padding-top: 18px;
`;

export const StyledPriceRowValue = styled(StyledRowValue)`
  display: inline-flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
`;

export const DiscountedPrice = styled.span`
  margin-right: 8px;
  font-size: 16px;
  font-weight: normal;
  text-decoration: line-through;
`;
